export default __webpack_public_path__ + "static/media/cegah (4).3b823683.png";